import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {ClientDgSearchResults} from "../models/datagrid-search-results/client.dg-search-results.model";
import {ClientsService} from "../providers/clients.service";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";

@Injectable()
export class ClientsResolve implements Resolve<ClientDgSearchResults> {
  constructor(private clientsService: ClientsService, private appStateService: AppStateService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<ClientDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.clientsService.getResults( environment.DEFAULT_RESULTS_LIMIT, 0, 'ASC', 'name').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
